import { GetterTree } from 'vuex';

import { QuizzesStateI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<QuizzesStateI, RootStateI> = {
};
